(function () {
  'use strict';
  var PX = 'cf';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var IC = {
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>'
  };
  var root = document.documentElement, STILL_KEY = 'cf-still';
  function still() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private window: the toggle still works for this visit */ } }

  /* ---- Pause motion: html.cf-still pauses every loop (the CSS bands); the choice is remembered ---- */
  function paused() { return root.classList.contains('cf-still'); }
  function syncPause() {
    var on = paused();
    [].slice.call(document.querySelectorAll('[data-cf-pause]')).forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  if (lsGet(STILL_KEY) === '1') root.classList.add('cf-still');
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cf-pause]') : null; if (!b) return;
    var on = !paused(); root.classList.toggle('cf-still', on); lsSet(STILL_KEY, on ? '1' : '0'); syncPause();
    document.dispatchEvent(new CustomEvent('cf:motion', { detail: { still: on } }));
  });

  /* ---- <cf-spy>: in-page anchors, smooth scroll, "current section" on the chips (a hidden controller element inside the chip nav) ---- */
  function anchorId(a) {
    /* "#buy", "/#faq" and (in the demo shell) "#/#faq" -> the id; anything that points at another page -> '' */
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  if (!customElements.get('cf-spy')) {
    customElements.define('cf-spy', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._on = {};
        this._click = function (e) {
          if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var a = e.target.closest ? e.target.closest('a[href]') : null; if (!a) return;
          var id = anchorId(a); if (!id) return;
          var t = document.getElementById(id); if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
          try { history.replaceState(null, '', '#' + id); } catch (er) { /* the page still scrolled */ }
          if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
          try { t.focus({ preventScroll: true }); } catch (er) { /* old browsers */ }
        };
        document.addEventListener('click', this._click);
        this._rs = function () { clearTimeout(self._rt); self._rt = setTimeout(function () { self.watch(); }, 200); };
        window.addEventListener('resize', this._rs);
        this.watch();
      }
      watch() {
        var self = this, els = [];
        if (this._io) { this._io.disconnect(); this._io = null; }
        this.links = [];
        [].slice.call(document.querySelectorAll('.cf-chip')).forEach(function (a) {
          var id = anchorId(a), el = id && document.getElementById(id);
          if (el) { self.links.push({ a: a, id: id, el: el }); if (els.indexOf(el) < 0) els.push(el); }
        });
        if (!els.length || !('IntersectionObserver' in window)) return;
        els.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
        this._els = els;
        /* the "reading band": from just under the top of the screen down to the middle of it */
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self._on[en.target.id] = en.isIntersecting; });
          self.mark();
        }, { rootMargin: '-16px 0px -' + Math.round(window.innerHeight * 0.5) + 'px 0px', threshold: 0 });
        els.forEach(function (el) { self._io.observe(el); });
      }
      mark() {
        var cur = '', on = this._on;
        (this._els || []).forEach(function (el) { if (on[el.id]) cur = el.id; });
        this.links.forEach(function (l) {
          var is = l.id === cur;
          l.a.classList.toggle('is-current', is);
          if (is) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        document.removeEventListener('click', this._click);
        window.removeEventListener('resize', this._rs);
        if (this._io) this._io.disconnect();
        clearTimeout(this._rt);
      }
    });
  }

  /* ---- <cf-kinetic>: bands pause off screen; scrolling speeds them up (scroll velocity -> playbackRate), eased back ---- */
  if (!customElements.get('cf-kinetic')) {
    customElements.define('cf-kinetic', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tracks = [].slice.call(this.querySelectorAll('[data-cf-track]'));
        this.rate = 1; this.target = 1; this.lastY = window.pageYOffset; this.lastT = 0; this.raf = 0; this.on = false;
        syncPause();
        if (!this.tracks.length || still() || !('IntersectionObserver' in window)) return;
        this._tick = function () {
          self.raf = 0;
          self.target = 1 + (self.target - 1) * 0.94;          /* the boost fades by itself ... */
          self.rate += (self.target - self.rate) * 0.18;       /* ... and the speed eases toward it */
          if (self.rate < 1.02 && self.target < 1.02) { self.rate = 1; self.target = 1; self.apply(); return; }
          self.apply();
          self.raf = requestAnimationFrame(self._tick);
        };
        this._scroll = function () {
          var now = performance.now(), y = window.pageYOffset;
          if (self.lastT) {
            var v = Math.abs(y - self.lastY) / Math.max(6, now - self.lastT), t = 1 + clamp(v * 2, 0, 5);
            if (t > self.target) self.target = t;
          }
          self.lastT = now; self.lastY = y;
          if (!self.raf && !paused()) self.raf = requestAnimationFrame(self._tick);
        };
        this._io = new IntersectionObserver(function (es) {
          var on = es[0].isIntersecting;
          self.classList.toggle('is-off', !on);
          if (on && !self.on) { self.on = true; self.lastT = 0; self.lastY = window.pageYOffset; window.addEventListener('scroll', self._scroll, { passive: true }); }
          else if (!on && self.on) { self.on = false; window.removeEventListener('scroll', self._scroll); }
        }, { threshold: 0 });
        this._io.observe(this);
      }
      apply() {
        var r = paused() ? 1 : this.rate;
        this.tracks.forEach(function (t) { (t.getAnimations ? t.getAnimations() : []).forEach(function (a) { a.playbackRate = r; }); });
      }
      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this._scroll) window.removeEventListener('scroll', this._scroll);
        if (this.raf) cancelAnimationFrame(this.raf);
      }
    });
  }

  /* ---- <cf-in>: below-the-fold blocks get a small offset (data-armed) and settle once, with their ticks and count-ups, when 25% of them is in view ---- */
  function countUp(b) {
    var to = parseInt(b.getAttribute('data-count'), 10); if (!isFinite(to) || to < 2) return;
    var t0 = performance.now(), dur = 900 + Math.min(to, 200) * 3;
    (function f(now) {
      var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      if (p < 1) { b.textContent = String(Math.round(to * e)); requestAnimationFrame(f); } else b.textContent = b.getAttribute('data-count');
    })(t0);
  }
  if (!customElements.get('cf-in')) {
    customElements.define('cf-in', class extends HTMLElement {
      connectedCallback() {
        var self = this, r = this.getBoundingClientRect();
        this.nums = [].slice.call(this.querySelectorAll('[data-count]'));
        if (still() || !('IntersectionObserver' in window) || r.top < window.innerHeight * 0.9) return;   /* already on screen (or above): nothing to arm */
        this.setAttribute('data-armed', '');
        this._io = new IntersectionObserver(function (es) {
          var e = es[0];
          if (e.isIntersecting) self.fire(true); else if (e.boundingClientRect.top < 0) self.fire(false);   /* scrolled past without stopping: just settle */
        }, { threshold: 0.25, rootMargin: '0px 0px -6% 0px' });
        this._io.observe(this);
      }
      fire(animate) {
        if (this._io) { this._io.disconnect(); this._io = null; }
        this.classList.add('is-in');
        if (animate) this.nums.forEach(countUp);
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    });
  }

  /* ---- <cf-delivery>: 7-10 business days from today (weekends skipped), en-US short dates ---- */
  function addBiz(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function shortDate(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
  if (!customElements.get('cf-delivery')) {
    customElements.define('cf-delivery', class extends HTMLElement {
      connectedCallback() {
        var lo = parseInt(this.getAttribute('data-min'), 10) || 7, hi = parseInt(this.getAttribute('data-max'), 10) || 10, now = new Date();
        var a = shortDate(addBiz(now, lo)), b = shortDate(addBiz(now, hi)), lead = this.querySelector('[data-cf-lead]'), win = this.querySelector('[data-cf-win]');
        if (!a || !b || !win) return;
        if (lead && lead.getAttribute('data-js')) lead.textContent = lead.getAttribute('data-js');
        win.textContent = a + ' – ' + b; win.hidden = false;
      }
    });
  }

  /* ---- <cf-pill>: the phone buy pill ---- */
  if (!customElements.get('cf-pill')) {
    customElements.define('cf-pill', class extends HTMLElement {
      connectedCallback() {
        var self = this, tgt = document.getElementById(this.getAttribute('data-target') || 'buy'), btn = tgt && tgt.querySelector('[data-add-button]');
        this.mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
        this.s = { btn: true, past: false, fin: false, foot: false };
        if (!btn || !('IntersectionObserver' in window)) return;
        this._mq = function () { self.apply(); };
        if (this.mq.addEventListener) this.mq.addEventListener('change', this._mq);
        this._io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.target === btn) { self.s.btn = e.isIntersecting; self.s.past = !e.isIntersecting && e.boundingClientRect.top < 0; }
            else if (e.target.classList.contains('cf-foot')) self.s.foot = e.isIntersecting;
            else self.s.fin = e.isIntersecting;
          });
          self.apply();
        }, { threshold: 0 });
        [btn, document.querySelector('.cf-final'), document.querySelector('.cf-foot')].forEach(function (el) { if (el) self._io.observe(el); });
        this.apply();
      }
      apply() {
        var s = this.s, phone = !!this.mq.matches, on = phone && s.past && !s.btn && !s.fin && !s.foot;
        root.classList.toggle('cf-has-pill', phone);
        this.classList.toggle('is-in', on);
        if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
      }
      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this.mq && this.mq.removeEventListener && this._mq) this.mq.removeEventListener('change', this._mq);
        root.classList.remove('cf-has-pill');
      }
    });
  }

  /* ---- <cf-fit>: "Is it right for you?" (the verdict is CSS driven by data-state / data-n) ---- */
  if (!customElements.get('cf-fit')) {
    customElements.define('cf-fit', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.qs = [].slice.call(this.querySelectorAll('.cf-q'));
        this.why = [].slice.call(this.querySelectorAll('.cf-why__i'));
        this.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') self.update(true); });
        this.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cf-reset]')) self.reset(); });
        this.update(false);
      }
      update(scroll) {
        var n = 0, no = 0, ans = [];
        this.qs.forEach(function (q) {
          var c = q.querySelector('input:checked'), a = c ? c.value : '';
          if (a) { q.setAttribute('data-a', a); n++; if (a === 'no') no++; } else q.removeAttribute('data-a');
          ans.push(a);
        });
        this.why.forEach(function (w) { w.hidden = ans[Number(w.getAttribute('data-why')) - 1] !== 'no'; });
        var state = n < this.qs.length ? 'idle' : (no ? 'maybe' : 'good'), was = this.getAttribute('data-state');
        this.setAttribute('data-n', String(n)); this.setAttribute('data-state', state);
        if (scroll && state !== 'idle' && was !== state) {
          var v = this.querySelector('.cf-fit__verdict'), r = v && v.getBoundingClientRect();
          if (r && (r.bottom > window.innerHeight || r.top < 0)) v.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
      reset() {
        [].slice.call(this.querySelectorAll('input[type=radio]')).forEach(function (i) { i.checked = false; });
        this.update(false);
        var f = this.querySelector('.cf-opt__in'); if (f) { try { f.focus({ preventScroll: false }); } catch (e) { f.focus(); } }
      }
    });
  }

  /* ---- bottom sheet mini cart ---- */
  var el = null, busy = false;
  function build() {
    if (el && document.body.contains(el)) return el;
    var W = words();
    el = document.createElement('div'); el.className = PX + '-ui'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + PX + '-ui__scrim" data-ui-close></div>' +
      '<section class="' + PX + '-ui__sheet" role="dialog" aria-modal="true" aria-label="' + esc(W.title) + '" tabindex="-1">' +
        '<span class="' + PX + '-ui__grip" aria-hidden="true"></span>' +
        '<div class="' + PX + '-ui__head"><div class="' + PX + '-ui__headline"><span class="' + PX + '-ui__ok" aria-hidden="true">' + CHECK + '</span>' +
          '<h2 class="' + PX + '-ui__title" data-ui-title>' + esc(W.title) + '</h2></div>' +
          '<button type="button" class="' + PX + '-ui__close" data-ui-close aria-label="' + esc(W.close) + '">' + IC.close + '</button></div>' +
        '<div class="' + PX + '-ui__body" aria-live="polite"></div><div class="' + PX + '-ui__foot"></div>' +
      '</section>';
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var q = e.target.closest('[data-ui-qty]');
      if (q && !busy) {
        busy = true;
        T().cart.change(q.getAttribute('data-key'), Number(q.getAttribute('data-ui-qty'))).then(function () { busy = false; return render(false); }).catch(function () { busy = false; });
      }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); return; } trap(el, e); });
    document.body.appendChild(el); return el;
  }
  function line(i, W, isNew) {
    var variant = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<span class="' + PX + '-ui__var">' + esc(i.variant_title) + '</span>' : '';
    return '<div class="' + PX + '-ui__line' + (isNew ? ' is-new' : '') + '" data-key="' + esc(i.key) + '">' + pic(i.image, 72) +
      '<div><a class="' + PX + '-ui__name" href="' + esc(i.url) + '"' + (isNew ? ' data-new="' + esc(W.added_tag || 'Added') + '"' : '') + '>' + esc(i.product_title || i.title) + '</a>' + variant +
        '<div class="' + PX + '-ui__ctrl"><div class="' + PX + '-ui__qty" role="group" aria-label="' + esc(W.qty) + '">' +
          '<button type="button" data-ui-qty="' + (i.quantity - 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.minus) + '">' + IC.minus + '</button>' +
          '<output>' + i.quantity + '</output>' +
          '<button type="button" data-ui-qty="' + (i.quantity + 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.plus) + '">' + IC.plus + '</button></div>' +
          '<button type="button" class="' + PX + '-ui__rm" data-ui-qty="0" data-key="' + esc(i.key) + '">' + esc(W.remove) + '</button></div></div>' +
      '<span class="' + PX + '-ui__price">' + money(i.final_line_price) + '</span>' + giftRow(i) + '</div>';
  }
  function isGift(i) { return !!(i.properties && i.properties._free_product === 'true'); }
  function giftRow(i) {
    /* the machine ships with its free gift (the Breville Barista Tool Kit): a $0 "Included free" sub-row with the whole-kit photo (64 px) + a "+ FREE" pill,
       rendered by Liquid into <template id="CfGiftTpl"> (snippets/cf-gifttpl.liquid) */
    var t = document.getElementById('CfGiftTpl');
    if (!t || !i || isGift(i) || t.getAttribute('data-handle') !== i.handle) return '';
    return '<div class="' + PX + '-ui__gift">' + t.innerHTML + '</div>';
  }
  function render(justAdded) {
    var W = words();
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + PX + '-ui__body'), foot = el.querySelector('.' + PX + '-ui__foot');
      var newKey = justAdded && lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      var title = el.querySelector('[data-ui-title]'), ok = el.querySelector('.' + PX + '-ui__ok');
      if (title) title.textContent = justAdded && c.items.length ? W.added : W.title;
      if (ok) ok.style.display = justAdded && c.items.length ? '' : 'none';
      body.innerHTML = c.items.length ? c.items.map(function (i) { return line(i, W, newKey && i.key === newKey); }).join('') : '<p class="' + PX + '-ui__empty">' + esc(W.empty) + '</p>';
      foot.innerHTML = '<div class="' + PX + '-ui__sum"><span class="' + PX + '-ui__sum-label">' + esc(W.subtotal) + ' · ' + count(c.item_count, W) + '</span><span class="' + PX + '-ui__dots" aria-hidden="true"></span>' +
          '<span class="' + PX + '-ui__sum-value">' + money(c.total_price) + '</span></div>' +
        '<p class="' + PX + '-ui__ship">' + esc(W.ship) + '</p>' +
        (c.items.length ? '<div class="' + PX + '-ui__buttons"><a class="' + PX + '-ui__btn" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a>' +
          '<a class="' + PX + '-ui__btn ' + PX + '-ui__btn--ghost" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>' : '') +
        '<button type="button" class="' + PX + '-ui__keep" data-ui-close>' + esc(W.keep) + '</button>';
    });
  }
  function openUi(justAdded) {
    build();
    if (!el.classList.contains('is-open')) lastFocus = document.activeElement;
    return render(justAdded).then(function () {
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); root.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__close'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }
    }).catch(function () {});
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); root.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* the page keeps its place */ } }
    lastAdded = null;
  }
  function afterAdd(after) {
    if (after === 'cart') return false;
    openUi(true);
    return true;
  }
  function init() {
    /* the cart icon in the top line opens the sheet; on the cart page itself it just follows the link */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.cf-top__cartlink') : null;
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (document.querySelector('boostly-cart-items')) return;
      e.preventDefault(); openUi(false);
    });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'cf';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
